// When adding a post, also update latestBlogPost.js if it is the newest by date.
import whatIsWebHostingBeginnersGuide2026Post from "./posts/what-is-web-hosting-beginners-guide-2026";
import dirtyFragLinuxKernelVulnerabilityPost from "./posts/dirty-frag-linux-kernel-vulnerability-patch-guide";
import howToInstallUptimeKumaAndMeasureUptime2026Post from "./posts/how-to-install-uptime-kuma-and-measure-uptime-2026";
import coreWebVitalsForWordpress2026Post from "./posts/core-web-vitals-for-wordpress-2026";
import howToMigrateWordpressToVpsWithoutDowntime2026Post from "./posts/how-to-migrate-wordpress-to-vps-without-downtime-2026";
import nodejsHostingOnVps2026Post from "./posts/nodejs-hosting-on-vps-2026";
import importanceOfSsl2026Post from "./posts/importance-of-ssl-2026";
import indiaLocationResellerHostingReleasePost from "./posts/india-location-reseller-hosting-release";
import changeSshPortPost from "./posts/change-ssh-port";
import bestCheapWebHostingIndiaPost from "./posts/best-cheap-web-hosting-india";
import sharedVsVpsVsCloudHosting2026Post from "./posts/shared-vs-vps-vs-cloud-hosting-2026";
import howFastHostingImprovesWebsiteSpeed2026Post from "./posts/how-fast-hosting-improves-website-speed-2026";
import speedUpWordpressOnCheapHosting2026Post from "./posts/speed-up-wordpress-on-cheap-hosting-2026";
import howToInstallCpanelInVpsPost from "./posts/how-to-install-cpanel-in-vps";
import whatIsOpenClawGuidePost from "./posts/what-is-openclaw-self-hosted-ai-agent-guide";
import howToOptimiseVpsServerPost from "./posts/how-to-optimise-vps-server";
import whyYourWebsiteIsSlowPost from "./posts/why-your-website-is-slow-and-what-to-do-about-it";
import differenceBetweenHttpAndHttpsPost from "./posts/difference-between-http-and-https";
import greenHostingChecklist2026Post from "./posts/green-hosting-checklist-2026";
import howToConnectDomainToHosting2026Post from "./posts/how-to-connect-domain-to-hosting-2026";
import howToEnableSslAfterDomainConnection2026Post from "./posts/how-to-enable-ssl-after-domain-connection-2026";
import howToFixMixedContentErrorsAfterSsl2026Post from "./posts/how-to-fix-mixed-content-errors-after-ssl-2026";
import howToForceHttpsInWordpressAndCpanel2026Post from "./posts/how-to-force-https-in-wordpress-and-cpanel-2026";
import howToSetCanonicalWwwVsNonWwwAfterHttps2026Post from "./posts/how-to-set-canonical-www-vs-non-www-after-https-2026";
import howToChooseAffordableResellerHosting2026Post from "./posts/how-to-choose-affordable-reseller-hosting-2026";
import howToCreateEmailOnClubhostySharedHosting2026Post from "./posts/how-to-create-and-manage-email-on-clubhosty-shared-hosting-2026";
import cpanelHostingVsSharedHosting2026Post from "./posts/cpanel-hosting-vs-shared-hosting-2026";
import sharedVsPlusVpsVsCloudVsDedicatedPost from "./posts/shared-hosting-vs-vps-vs-cloud-vs-dedicated-2026";
import howToImportBackupInHosting2026Post from "./posts/how-to-import-backup-in-hosting-2026";
import whyDailyBackupIsImportantForWebsite2026Post from "./posts/why-daily-backup-is-important-for-website-2026";
import whyUseWhmcsForHostingBusiness2026Post from "./posts/why-use-whmcs-for-hosting-business-2026";
import pleskVsCpanelPost from "./posts/plesk-vs-cpanel-2026";
import domainTradingGuide2026Post from "./posts/domain-trading-guide-2026";
import colocationHostingGuide2026Post from "./posts/colocation-hosting-guide-2026";
import affordableWebHostingClubhosty2026Post from "./posts/affordable-web-hosting-clubhosty-2026";
import howToRunLlmOnVpsServer2026Post from "./posts/how-to-run-llm-on-vps-server-2026";
import howToHostSelfHostedAiAgentOnVps2026Post from "./posts/how-to-host-self-hosted-ai-agent-on-vps-2026";
import howToSecureWordPressOnSharedHosting2026Post from "./posts/how-to-secure-wordpress-on-shared-hosting-2026";
import whyBuyHostingFromClubhosty2026Post from "./posts/why-buy-hosting-from-clubhosty-2026";
import amdVpsHostingIndia2026Post from "./posts/amd-vps-hosting-india-2026";
import globalVpsLocations9Post from "./posts/9-global-vps-server-locations-clubhosty-2026";
import whyChangingHostingProvidersHurtsWebsite2026Post from "./posts/why-changing-hosting-providers-hurts-website-2026";

export const BLOG_DEFAULT_IMAGE =
  "/blog-images/affordable-web-hosting.jpg";

export const blogPosts = [
  globalVpsLocations9Post,
  whyChangingHostingProvidersHurtsWebsite2026Post,
  amdVpsHostingIndia2026Post,
  whyBuyHostingFromClubhosty2026Post,
  howToSecureWordPressOnSharedHosting2026Post,
  howToRunLlmOnVpsServer2026Post,
  howToHostSelfHostedAiAgentOnVps2026Post,
  affordableWebHostingClubhosty2026Post,
  colocationHostingGuide2026Post,
  whatIsWebHostingBeginnersGuide2026Post,
  howToInstallUptimeKumaAndMeasureUptime2026Post,
  coreWebVitalsForWordpress2026Post,
  howToMigrateWordpressToVpsWithoutDowntime2026Post,
  domainTradingGuide2026Post,
  pleskVsCpanelPost,
  importanceOfSsl2026Post,
  nodejsHostingOnVps2026Post,
  indiaLocationResellerHostingReleasePost,
  dirtyFragLinuxKernelVulnerabilityPost,
  whyUseWhmcsForHostingBusiness2026Post,
  whyDailyBackupIsImportantForWebsite2026Post,
  howToImportBackupInHosting2026Post,
  sharedVsPlusVpsVsCloudVsDedicatedPost,
  cpanelHostingVsSharedHosting2026Post,
  howToCreateEmailOnClubhostySharedHosting2026Post,
  howToChooseAffordableResellerHosting2026Post,
  howToSetCanonicalWwwVsNonWwwAfterHttps2026Post,
  howToForceHttpsInWordpressAndCpanel2026Post,
  howToFixMixedContentErrorsAfterSsl2026Post,
  howToEnableSslAfterDomainConnection2026Post,
  howToConnectDomainToHosting2026Post,
  greenHostingChecklist2026Post,
  differenceBetweenHttpAndHttpsPost,
  whyYourWebsiteIsSlowPost,
  howToOptimiseVpsServerPost,
  whatIsOpenClawGuidePost,
  howToInstallCpanelInVpsPost,
  howFastHostingImprovesWebsiteSpeed2026Post,
  speedUpWordpressOnCheapHosting2026Post,
  sharedVsVpsVsCloudHosting2026Post,
  bestCheapWebHostingIndiaPost,
  changeSshPortPost,
].map((post) => ({
  ...post,
  image: post.image || BLOG_DEFAULT_IMAGE,
}));

export const getBlogPostBySlug = (slug) =>
  blogPosts.find((post) => post.slug === slug);